// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { useEffect } from "react";
import {
  Typography,
  DialogTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

export default function ErrorDialog(props) {
  const handleClose = () => {
    props.handleOpen();
  };

  useEffect(() => {}, [props.open, props.message]);

  return (
    <Dialog
      fullWidth
      open={props.open}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
    >
      <DialogTitle id="error-dialog-title">
        <Typography variant="h4">{"Error"}</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="error-dialog-description">
          {props.message ? props.message : "The application ran into an error!"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant={"contained"}
          color={"secondary"}
          autoFocus
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
